import type { SearchParameters } from 'lib-search-types';
import { Merge } from 'ts-essentials';

import { AppPathConfig } from 'utils/url/appPaths';
import { createAppUrl } from 'utils/url/createAppUrl';

import { SearchViewScope } from '../../search.types';
import { convertFiltersObjectToString } from '../filters/convertFilters';
import { convertSortObjectToString } from '../sort/convertSort';

type CreateSearchUrlParams = Merge<
  SearchParameters<'conversations'>,
  {
    scope: SearchViewScope;
  }
>;

/**
 * Creates a Search URL params object that can be passed to `AppLink`.
 *
 * @param params The current Search parameters
 */
export function createSearchUrlParams(
  params: CreateSearchUrlParams,
): AppPathConfig['/search/:scope'] {
  const { query, filters, isStrict, page, sortBy } = params;

  return {
    path: {
      scope: params.scope,
    },
    search: {
      q: query || undefined,
      filters: convertFiltersObjectToString(filters) || undefined,
      sort: convertSortObjectToString(sortBy) || undefined,
      strict: isStrict ? 'true' : undefined,
      page: page && page > 1 ? page.toString() : undefined,
    },
  };
}

/**
 * Creates a Search URL with supported path and query parameters.
 *
 * @param params The current Search parameters
 */
export function createSearchUrl(params: CreateSearchUrlParams): string {
  const url = createAppUrl({
    path: '/search/:scope',
    params: createSearchUrlParams(params),
  });

  return url;
}
